import { ref, readonly } from 'vue'
import { Auth } from '@/services/Backend/Auth'
import type { User } from '@/models/User'

const authService = new Auth()

const _user = ref<User | null | undefined>(undefined)
export const user = readonly(_user)

const _canRegister = ref(false)
export const canRegister = readonly(_canRegister)

export async function checkAuth(): Promise<void> {
    const { user: u, canRegister: cr } = await authService.me()
    _user.value = u
    _canRegister.value = cr
}

export async function login(email: string, password: string, remember: boolean = false): Promise<'ok' | 'totp'> {
    const result = await authService.login(email, password, remember)
    if ('twoFactorRequired' in result) return 'totp'
    _user.value = result
    return 'ok'
}

export async function register(name: string, email: string, password: string, passwordConfirmation: string, remember: boolean = false, turnstileToken: string = ''): Promise<void> {
    _user.value = await authService.register(name, email, password, passwordConfirmation, remember, turnstileToken)
}

export async function verifyTotp(code: string): Promise<void> {
    _user.value = await authService.verifyTotp(code)
}

export async function logout(): Promise<void> {
    await authService.logout()
    _user.value = null
}
